import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-5.5rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-84" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-85" data-mp="23wmfz15qb7fj">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-green sm:text-xs" data-id="element-86" data-mp="30lu1482freix">
          IL CURRICULUM COMPLETO DI SCIENZE
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-deep sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-87" data-mp="2mrta60hq6vt4">
          Insegna un Anno Intero di <span className="italic text-brand-green" data-id="element-88" data-mp="3fh09v2sx1rfy">Scienze</span> in 5 Minuti di
          Preparazione
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-89" data-mp="3kamfib0nwv29">
          Biologia Pronta è il curriculum completo di Scienze pronto all’uso per la scuola primaria e secondaria di
          primo grado — lezioni, attività pratiche e verifiche già pronte, così non passi più la domenica a preparare
          materiale.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/eQLzYBn9E8LfmkWjATz3cu/chat_gpt_mockup-Photoroom.png" alt="Il pacchetto completo Biologia Pronta: dodici volumi di scienze, materiale digitale con Ugo il Gufo e cinque quaderni bonus" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-90" data-mp="2kdto4azf1ubf" />
        <div className="flex w-full flex-col items-center" data-id="element-91" data-mp="3365xvisefxvl">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-92" data-mp="1dq6ihjy6tc7i">
            OTTIENI BIOLOGIA PRONTA ORA
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-93" data-mp="18tg4d25y0qoq">
            ✓ Accesso immediato <span className="px-1 text-brand-amber" data-id="element-94" data-mp="3dth4be9yq598">·</span> ✓ Materiale stampabile e digitale
          </p>
        </div>
      </motion.div>
    </section>;
}